import React from 'react';
import PropTypes from 'prop-types';
import BasicPageHeader from 'components/admin/basic/BasicPageHeader';
import ResultTitle from 'components/admin/result/ResultTitle';
import ClubRecord from 'components/admin/result/ClubRecord';
import BackEventButton from 'components/admin/result/BackEventButton';

const EventResultPageHeader = ({
  meet,
  clubId,
  title,
  suffix,
  viewLabel,
  clubRecords,
  eventType,
  viewType,
  showBackButton = true,
}) => {
  return (
    <BasicPageHeader
      leftChild={
        <>
          <ResultTitle title={title} suffix={suffix} viewLabel={viewLabel} />
          <ClubRecord clubRecords={clubRecords} eventType={eventType} />
        </>
      }
      rightChild={
        showBackButton && (
          <BackEventButton meet={meet} clubId={clubId} viewType={viewType} />
        )
      }
    ></BasicPageHeader>
  );
};

EventResultPageHeader.propTypes = {
  title: PropTypes.string,
  suffix: PropTypes.string,
  viewLabel: PropTypes.string,
  clubRecords: PropTypes.arrayOf(PropTypes.object),
  eventType: PropTypes.string,
  meet: PropTypes.object,
  clubId: PropTypes.string,
  viewType: PropTypes.string,
  showBackButton: PropTypes.string,
};

export default EventResultPageHeader;
